<template>
  <div class="-mx-2.5 flex flex-wrap">
    <Lazy
      v-for="(product, productIndex) in products"
      :key="product.id"
      render-on-idle
      style="min-height: 100px"
      class="p-2.5"
      :class="{
        'w-full': displayType === DisplayType.LIST,
        'w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5': displayType === DisplayType.GRID,
        'w-full md:w-1/2 lg:w-1/3 xl:w-1/4':
          displayType === DisplayType.GRID_EXTENDED,
      }"
    >
      <ProductCard
        class="h-full"
        :product="product"
        :display-type="displayType"
        :is-first="isFirst && productIndex === 0"
      />
    </Lazy>
  </div>
</template>

<script lang="ts" setup>
import ProductCard from '@menu/Shared/ProductCard.vue';
import Lazy from '@menu/Shared/Lazy.vue';
import { DisplayType } from '@/menu/Types/Enums/DisplayType';
import { ProductResource } from '@/menu/Types/Resources/ProductResource';
import { computed } from 'vue';
import { useCurrentMenu } from '@menu/Composables/useCurrentMenu';
import getRestaurant from '@menu/Utils/getRestaurant';

const props = defineProps<{
  products: ProductResource[];
  overrideDisplayType?: DisplayType;
  isFirst?: boolean;
}>();

const restaurant = getRestaurant();
const { menu } = useCurrentMenu();

const displayType = computed<DisplayType>(
  () =>
    props.overrideDisplayType ??
    menu.value.menuItemsDisplayType ??
    restaurant.menuItemsDisplayType,
);
</script>
